import { onlineManager } from "@tanstack/react-query";

export class OfflineError extends Error {
  constructor() {
    super("You are offline. Please reconnect and try again.");
    this.name = "OfflineError";
  }
}

export const assertOnline = (): void => {
  if (
    (typeof navigator !== "undefined" && !navigator.onLine) ||
    !onlineManager.isOnline()
  ) {
    throw new OfflineError();
  }
};

/** Fail before dispatch. Recovery/retries stay with the caller's library. */
export const guardNetworkRequest =
  <Args extends unknown[], Result>(
    request: (...args: Args) => Promise<Result>
  ): ((...args: Args) => Promise<Result>) =>
  async (...args) => {
    assertOnline();
    return await request(...args);
  };
